import { useCallback, type FC, type MouseEvent } from 'react';
import { useDispatch } from 'react-redux';
import { updateUriRef } from '../../../actions/filterActions.ts';

// components
import { SbSharedRefineMenuLink } from '../../SbSharedRefineMenu/SbSharedRefineMenuLink/SbSharedRefineMenuLink.tsx';
import { SbSharedRefineMenuExpandableItemList } from '../../SbSharedRefineMenu/SbSharedRefineMenuExpandableItemList/SbSharedRefineMenuExpandableItemList.tsx';

type FilterValue = {
    readonly displayName?: string | null;
    readonly count?: number | null;
    readonly linkReference?: string | null;
    readonly linkable?: boolean | null;
    isHidden?: boolean;
} | null;

type Props = {
    filterName: string;
    values?: ReadonlyArray<FilterValue> | null;
    shouldIndent?: boolean;
    shouldUseExpandableList?: boolean;
    trackingOptions?: Record<string, unknown>;
};

export const SbRespRefineMenuLinkList: FC<Props> = ({
    filterName,
    values,
    shouldIndent,
    shouldUseExpandableList = true,
    trackingOptions,
}) => {
    const dispatch = useDispatch();
    const onClick = useCallback(
        (filterValue: FilterValue, event: MouseEvent) => {
            dispatch(updateUriRef({ filterName, filterValue, event, trackingOptions }));
        },
        [dispatch, filterName, trackingOptions]
    );
    if (!shouldUseExpandableList) {
        return values?.map(value => {
            const { displayName, count, linkReference, linkable, isHidden } = value || {};
            return (
                <SbSharedRefineMenuLink
                    onClick={e => {
                        e.preventDefault();
                        onClick(value, e);
                    }}
                    count={count}
                    linkReference={linkReference}
                    linkable={linkable}
                    key={displayName}
                    text={displayName || ''}
                    shouldIndent={shouldIndent}
                    isHidden={isHidden}
                />
            );
        });
    }

    return (
        <SbSharedRefineMenuExpandableItemList
            filterName={filterName}
            availableFilterValues={values}
        >
            {({ valuesToShow }: { valuesToShow: FilterValue[] }) =>
                valuesToShow.map(value => {
                    const { displayName, count, linkReference, linkable, isHidden } = value || {};
                    return (
                        <SbSharedRefineMenuLink
                            onClick={e => {
                                e.preventDefault();
                                onClick(value, e);
                            }}
                            count={count}
                            linkReference={linkReference}
                            linkable={linkable}
                            key={displayName}
                            text={displayName || ''}
                            shouldIndent={shouldIndent}
                            isHidden={isHidden}
                        />
                    );
                })
            }
        </SbSharedRefineMenuExpandableItemList>
    );
};
